import { Outlet } from 'react-router-dom'
import PageTabs from '../shared/PageTabs.jsx'

const tabs = [
  { path: '/deals/part-ex/quote-requested', label: 'Quote Requested' },
  { path: '/deals/part-ex/quote-sent', label: 'Quote Sent' },
  { path: '/deals/part-ex/awaiting-collection', label: 'Awaiting Collection' },
  { path: '/deals/part-ex/shipping-arranged', label: 'Shipping Arranged' },
  { path: '/deals/part-ex/received', label: 'Received' },
  { path: '/deals/part-ex/accepted', label: 'Accepted' },
  { path: '/deals/part-ex/expired', label: 'Expired' },
]

export default function PartExPage() {
  return (
    <div>
      {/* This strip is nested under the Deals tabs, hence the tighter spacing. */}
      <PageTabs tabs={tabs} match="exact" style={{ marginTop: 8, fontSize: 13 }} />
      <Outlet />
    </div>
  )
}
